export { ETabKeys, ETabValue };
import DataHistoryInterface, {
  PenjualanInterface,
} from 'interface/reducers/history';
import RouteHistoryInterface from 'interface/router';
import AuthInterface, { UserDataInterface } from 'interface/reducers/auth';
import DataUIInterface from 'interface/reducers/ui';
import DataPostalCodeInterface, {
  CountriesStateInterface,
  ProvinceStateInterface,
} from 'interface/reducers/postalCode';

enum ETabKeys {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Active = 'Active',
  History = 'History',
}

enum ETabValue {
  Pending = 'pending',
  Active = 'active',
  InProgress = 'in_progress',
  History = 'history',
}

export namespace NSConsignment {
  type TTabKeys = ETabKeys;
  type TTabValue = ETabValue;

  type TStateToProps = {
    dataHistory: DataHistoryInterface;
    dataAuth: AuthInterface;
    dataUi: DataUIInterface;
    dataPostalCode: DataPostalCodeInterface;
    dataTopUp: { pengisian: any; topUp: any };
  };

  interface IModalSelectLocationActionProps {
    fetchCountries: () => Promise<unknown>;
    fetchProvinces: (param) => Promise<unknown>;
    updateProfile: (param) => Promise<unknown>;
    updateUserCountry: (param) => Promise<unknown>;
    fetchCurrencyRate: (param) => Promise<unknown>;
    refreshToken: () => Promise<unknown>;
    fetchProfile: () => Promise<unknown>;
  }

  interface IFormTabToolbar {
    keyword?: string;
    sort_by?: string;
    category?: string;
    order_status?: string;
    page: number;
    sneakers_condition?: string;
  }

  interface IGetListParams extends IFormTabToolbar {}
}
